import React from 'react'
import './subject.css'
import Option from './Option'

class SingleChoice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: ["", "", "", ""]
        }
        this.optionContentChange = this.optionContentChange.bind(this);
        this.deleteOption = this.deleteOption.bind(this);
        this.addOption = this.addOption.bind(this);
    }

    optionContentChange(id, content) {
        this.setState((preState)=>{
            const newState = preState;
            newState.options[id] = content;
            return newState;
        });
    }

    deleteOption(id) {
        this.setState((preState)=>{
            const newState = preState;
            const cnt = newState.options.length;
            newState.options[id] = "jj";
            for (let i = id; i < cnt - 1; i ++) {
                newState.options[i] = newState.options[i + 1];
            }
            newState.options.pop();
            return newState;
        });
    }

    addOption() {
        this.setState((preState)=>{
            const newState = preState;
            newState.options.push("");
            return newState;
        });
    }

    render() {
        const options = [];
        for (let i = 0; i < this.state.options.length; i ++) {
            options.push(
                <Option id={i} content={this.state.options[i]} onChange={this.optionContentChange} deleteSelf={this.deleteOption} />
            )
        }
        return (
            <div className="subject-single-choice">
                <div className="subject-entry">

                    <div class='checkbox'>
                        <input type='checkbox' id={'checkbox' + this.props.id} name='checkboox[]'></input>
                        <label for={'checkbox' + this.props.id}></label>
                    </div>
                    <p className="subject-entry-word">{this.props.id}.单选题</p>
                    <textarea className="subject-entry-input subject-single-title" placeholder="题目内容"></textarea>
                </div>
                {options}
                <div className="subject-entry">
                    <div className="subject-entry-img" onClick={this.addOption} ><img className="subject-img-sub" src={require("../assert/add_gray.png")}></img></div>
                    <p className="subject-entry-word">&ensp;</p>
                    <textarea className="subject-entry-input subject-single-title" placeholder="选项内容"></textarea>
                </div>
                <div className="subject-aline"></div>
            </div>
        );
    }
}

export default SingleChoice;